var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"psb-total",class:{'psb-total_highlighted': (_vm.amount > 0)}},[_c('span',[_vm._v(_vm._s(_vm.label)+": ")]),_c('p',[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.amount,_vm.currency)))])])}
var staticRenderFns = []

export { render, staticRenderFns }